module.exports = __webpack_public_path__ + "app-logo-ventura.c3bacd55a3589b7ccfaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app-logo-ventura.png
// module id = 1377
// module chunks = 2